import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'

interface UseAdvancePublicCompanyLeadContactProps {
  contactId?: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useAdvancePublicCompanyLeadContact = ({
  contactId,
  onSuccess,
  onError,
}: UseAdvancePublicCompanyLeadContactProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['advancePublicCompanyLeadContact'],
    mutationFn: async () => {
      await privateAxios.put(`/funnel/contacts/${contactId}/advance`)
    },
    onSuccess,
    onError,
  })
}
